import { useState } from "react";
import { useNavigate } from "react-router";
import { useWorkspacesStore } from "@/stores/workspaces-store";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface DialogProps {
  params: Record<string, string>;
  onClose: () => void;
}

export function CreateWorkspaceDialog({ onClose }: DialogProps) {
  const [name, setName] = useState("");
  const [n8nUrl, setN8nUrl] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { add } = useWorkspacesStore();
  const navigate = useNavigate();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim() || !n8nUrl.trim() || submitting) return;
    setSubmitting(true);
    try {
      const workspace = await add({ name: name.trim(), n8nUrl: n8nUrl.trim() });
      setName("");
      setN8nUrl("");
      onClose();
      navigate(`/workspace/${workspace.id}`);
    } catch {
      setSubmitting(false);
    }
  }

  return (
    <Dialog open onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Create new workspace</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="workspace-name">Workspace name</Label>
            <Input
              id="workspace-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="My workflow"
              required
              autoFocus
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="n8n-url">n8n Instance URL</Label>
            <Input
              id="n8n-url"
              type="url"
              value={n8nUrl}
              onChange={(e) => setN8nUrl(e.target.value)}
              placeholder="https://your-n8n.example.com"
              required
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={!name.trim() || !n8nUrl.trim() || submitting}>
              {submitting ? "Creating..." : "Create workspace"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
